module.exports = __webpack_public_path__ + "static/media/Cats eyes 05_FRANSKA-mixdown.0e6f6f8a.mp3";